import { memo } from 'react';

import { Row } from '../components/index.ts';
import type { RowProps } from '../components/Row/types.ts';
import { renderDndColumns } from './renderDndColumns.tsx';
import type { DndColumn, UseDndRowOptions } from './types.ts';
import { useDndRow } from './useDndRow.ts';

type RowFeatureProps = Pick<RowProps, 'expandableContent' | 'subRows' | 'flash' | 'highlighted' | 'withCellDividers' | 'dataTestId'>;

export interface DndRowProps extends UseDndRowOptions, RowFeatureProps {
  columns: DndColumn[];
  /**
   * Extra props forwarded to each column's component. `DndRow` is memoized, so for large lists pass
   * a referentially stable object (e.g. `useMemo`, or render rows through a memoized wrapper as in
   * the ComplexDataExample story) — an inline `{{ item }}` literal defeats the memo.
   */
  itemProps?: Record<string, unknown>;
}

export const DndRow = memo(function DndRow({ id, index, group, columns, itemProps, ...rowProps }: DndRowProps) {
  const { ref, dragHandleRef, targetRef, isDragging } = useDndRow({ id, index, group });

  return (
    <Row ref={ref} targetRef={targetRef} isDragging={isDragging} {...rowProps}>
      {renderDndColumns(columns, { ...itemProps, dragHandleRef })}
    </Row>
  );
});
